import { types as phonesOrderTypes } from '@/constants/phones_constants';

export default {
  data() {
    return {
      useNullablePhonesOrderType: true,
    };
  },
  computed: {
    phonesOrderTypeItems() {
      const items = [];
      if (this.useNullablePhonesOrderType) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(phonesOrderTypes)
        .forEach((key) => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.phones_order_types.${phonesOrderTypes[key]}`),
            value: phonesOrderTypes[key],
          });
        });
      return items;
    },
  },
};
